module.exports = __webpack_public_path__ + "static/media/powerpoint.63f01939.svg";